import React from "react";
import {
    FormTab,
    Show,
    TextInput,
    TabbedForm, Toolbar
} from 'react-admin';
import {makeStyles} from "@material-ui/core";

const useStyles = makeStyles((theme) => ({
    pais: {display: 'inline-block', width: 400, marginLeft: 8},
    pais_codigo_afip: {display: 'inline-block', width: 200, marginLeft: 8},
    pais_codigo_gestion: {display: 'inline-block', width: 200, marginLeft: 8},
}));

const CompraCptShow = props => {
    const PostTitle = ({record}) => {
        return <span>Concepto de Requerimiento: {record ? `${record.requerimiento_concepto_d}` : ''}</span>;
    };

    const PostEditActions = ({basePath, data, resource}) => (
        <Toolbar {...props}>
            <>
            </>
        </Toolbar>
    );

    return (
        <Show title={<PostTitle/>} actions={<PostEditActions/>} {...props}>
            <TabbedForm>
                <FormTab label="Concepto de Requerimiento">
                    <TextInput label="Req. Concepto" source="requerimiento_concepto" inputProps={{readOnly: true}}/>
                    <TextInput label="Descripción" source="requerimiento_concepto_d" inputProps={{readOnly: true}}/>
                </FormTab>
            </TabbedForm>
        </Show>
    )
};
export default CompraCptShow;


